
import styles from "./ReviewCards.module.css"; 

const ReviewCards = () => {
  const values = [
    {name: 'Kavya Veer', role: 'College Student', reviewContent: 'I am currently studying at IIIT Hyderabad. K. P. Jadhav High School & Junior College has given me a strong educational foundation in a nurturing environment. The dedicated teachers and diverse extracurricular activities have contributed to my overall growth beyond academics. I am grateful to be associated with this institution!'},
    {name: ' Meena Jagtap', role: 'Parent', reviewContent: "के. पी. जाधव हायस्कूल आणि ज्युनियर कॉलेजमध्ये अभ्यासाबरोबरच विविध उपक्रमांनाही महत्त्व दिले जाते. शाळेतील कार्यक्रमांमुळे माझ्या मुलाचा आत्मविश्वास वाढला आणि नेतृत्व कौशल्य विकसित झाले. इथले शिक्षक खूप समजूतदार आणि मदतीसाठी नेहमी तयार असतात. "},
    {name: 'Yashvardhan Borude', role: 'College Student', reviewContent: 'The College has given me great opportunities to explore my interests. The annual sports event, science fair, and cultural activities make learning exciting. The teachers motivate us to do our best!'},
    {name: 'Anuksha Yadav', role: 'College Student', reviewContent: 'The teachers at K. P. Jadhav High School & Junior College are always supportive, approachable, and dedicated to helping students succeed. My time here provided me with a solid academic foundation, which has been instrumental in my journey. Now, as a student at Government Dental College, Mumbai, I deeply appreciate the guidance and education that shaped my path.'}
  ];

  return (
    <div className={styles.cardsContainer}>
       
      {values.map((value, index) => (
        <div className={styles.card} key={index}>
             <img className={styles.openingQuote} src="/icons/openingQuotes.png" alt="opening quote"/>
          <p className={styles.name}>{value.name}</p>
          <p className={styles.role}>{value.role}</p>
          <p className={styles.content}>{value.reviewContent}</p>
          <img className={styles.closingQuote} src="/icons/closingQuotes.png" alt="closing quote"/>
        </div>
      ))}
    </div>
  );
};

export default ReviewCards;
